const customColumnCalculations = [
  {
    targetHeader: "Night Dual Received", // where the result goes
    sourceHeaders: ["Night", "Dual Received / Flight Training"], // what to sum
    format: "decimal" 
  },
  {
    targetHeader: "Night/PIC", // where the result goes
    sourceHeaders: ["Night", "PIC"], // what to sum
    format: "decimal" 
  },
  {
    targetHeader: "Sim Ins. Aircraft", // where the result goes
    sourceHeaders: ["Sim Instrument", ["SEL Time", "MEL Time"]], // what to sum
    format: "decimal"
  },
  {
    targetHeader: "Sim Ins. FTD", // where the result goes
    sourceHeaders: ["Sim Instrument", "Simulator Time"], // what to sum
    format: "decimal"
  },
  {
    targetHeader: "Cross Country Instruction Received", // where the result goes
    sourceHeaders: ["Cross Country", "Dual Received / Flight Training"], // what to sum
    format: "decimal"
  },
  {
    targetHeader: "Solo Cross Country", // where the result goes
    sourceHeaders: ["Cross Country", "Solo"], // what to sum
    format: "decimal"
  },
  {
    targetHeader: "Total Time",
    sourceHeaders: [["SEL Time", "MEL Time"]],  // OR condition: SEL Time OR MEL Time
    format: "decimal"
  }
];

const getMasterTableTemplate = () => {
  try {
    const jsonValue = sessionStorage.getItem('masterTableTemplate'); // string
    if (jsonValue != null) {
      const parsedValue = JSON.parse(jsonValue); // parse only once
      return parsedValue;
    } else {
      return null;
    }
  } catch (error) {
    return null;
  }
};

export default function AutoSum(tableData) {
  const masterTemplate = getMasterTableTemplate();
  if (!masterTemplate) {
    //console.warn("No masterTemplate found. Skipping decision logic.");
    return tableData;
  }

  const headerRowCount = 1; 
  const dataRows = tableData.data.slice(headerRowCount);
  const columnCount = tableData.data[0].length;

  // Initialize totals row with empty values
  let totalsRow = Array(columnCount).fill("");

  for (let colIndex = 0; colIndex < columnCount; colIndex++) {
    const columnTemplate = masterTemplate.find(t => t.index === colIndex + 1);

    if (columnTemplate && columnTemplate.dataType === "number") {
      let sum = 0;

      for (const row of dataRows) {
        const value = row[colIndex];
        const parsed = parseFloat(value);

        if (!isNaN(parsed)) {
          sum += parsed;
        }
      }

      if (columnTemplate.numberFormat === "integer") {
        totalsRow[colIndex] = Math.round(sum);
      } else if (columnTemplate.numberFormat === "decimal") {
        totalsRow[colIndex] = (sum).toFixed(1);
      }
    }
  }

  totalsRow[0] = "Totals";

  // Apply custom rules
  totalsRow = performCustomColumnMath(dataRows, totalsRow, masterTemplate, customColumnCalculations);

  // Don’t mutate original — return a new table
  return {
    ...tableData,
    data: [...tableData.data, totalsRow]
  };
}

function performCustomColumnMath(dataRows, totalsRow, masterTemplate, customCalculations) {
  const getColIndex = (name) => {
    const entry = masterTemplate.find(t => t.name === name);
    return entry ? entry.index - 1 : null;
  };

  const formatValue = (sum, format) => {
    return format === "integer" ? Math.round(sum) : parseFloat(sum).toFixed(1);
  };

  for (const rule of customCalculations) {
    const targetIdx = getColIndex(rule.targetHeader);
    if (targetIdx === null) continue;

    let sum = 0;

    for (const row of dataRows) {
      let rowSum = 0;
      let allBlank = true;
      let valid = true;

      for (const header of rule.sourceHeaders) {
        let value = null;

        if (Array.isArray(header)) {
          let foundValid = false;
          for (const option of header) {
            const idx = getColIndex(option);
            if (idx === null) continue;
            const cellVal = row[idx];
            const val = parseFloat(cellVal);
            if (!isNaN(val) && cellVal !== "") {
              value = val;
              foundValid = true;
              break;
            }
          }
          if (!foundValid) value = null;
        } else {
          const idx = getColIndex(header);
          if (idx === null) {
            valid = false;
            break;
          }
          const cellVal = row[idx];
          const val = parseFloat(cellVal);
          if (isNaN(val) || cellVal === "") {
            valid = false;
            break;
          }
          value = val;
        }

        if (value === null) {
          continue;
        } else {
          rowSum += value;
          allBlank = false;
        }
      }

      if (!valid || allBlank) {
        row[targetIdx] = "";
      } else {
        row[targetIdx] = formatValue(rowSum, rule.format);
        sum += rowSum;
      }
    }

    totalsRow[targetIdx] = sum === 0 ? "" : formatValue(sum, rule.format);
  }

  return totalsRow;
}
